import { $api } from '../y/api';
import { $i18n, YI18NString } from '../y/i18n';
import { $time, YTime } from '../y/time';
import { YCountryId, YId, YTimeString } from '../y/types';
import { c_cities, CCityId } from './c-city';
import { CEventId } from './c-event';
import { CEventTagId } from './c-event-tag';

export interface CEventHomeListView {
    id: CEventId;
    name: YI18NString;
    city_id: CCityId;
    slug: string;
    venue_name: string;
    event_tag_ids: CEventTagId[];
    session_times: YTimeString[];
    is_loyalty: boolean;
    rating_score: number;
    picture_id: YId;
    dots: number;
}

export function cEventHomeListViewNextSessionTime(event: CEventHomeListView, after?: YTime) {
    let times = event.session_times;
    if(times.length) {
        if(after) {
            const filtered = times.filter(s => $time(s).after(after));
            if(filtered.length)
                times = filtered;
        }
        if(times.length > 1)
            return $i18n.tl.several_dates;
        //TODOURGENT
        // return $time(times[0]).formatIn(times[0].drop_in ? 'd MMM' : 'd MMM, HH:mm', 'Europe/Stockholm');
        return $time(times[0]).formatIn('d MMM, HH:mm', 'Europe/Stockholm');
    }

    // const model = this.model;
    // if(model.videos && model.videos.length && this.isVideoAvailable(model.videos[0])) {
    //     const time = $time(model.videos[0].date);
    //     if(time.is_future) {
    //         return $i18n.tl.t_video_starts + ' ' + time.format('d MMM, HH:mm');
    //     } else if(time.add(model.length, $time.minute).is_future) {
    //         return $i18n.tl.t_video_live_now;
    //     }
    // }

    return;
}

export function cEventHomeListViewScreenLocation(event: CEventHomeListView) {
    return ['event', c_cities.maybe(event.city_id)!.slug, event.slug];
}

export function cEventsHomeListViewFeaturedByCountry(country: YCountryId) {
    return $api.GET<CEventHomeListView[]>(`c/events/home_list_view/featured/${country}`);
}